import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listSupplier (URL, header, success, error) {
    Vue.axios.get(URL + 'supplier', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  exportSupplier(URL, header, success, error) {
    Vue.axios.get(URL + 'supplierexport', header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getSupplier (URL, Id, header, success, error) {
    Vue.axios.get(URL + 'supplier/' + Id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addSupplier (URL, obj, header, success, error) {
    Vue.axios.post(URL + 'supplier', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editSupplier (URL, obj, Id, header, success, error) {
    Vue.axios.put(URL + 'supplier/' + Id, obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteSupplier (URL, Id, header, success, error) {
    Vue.axios.delete(URL + 'supplier/' + Id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/supplier.js